<div (keydown.shift.tab)="$event.preventDefault()">
  <mat-select disableOptionCentering [formControl]="myControl" (selectionChange)="onSeveritySelected($event.value)" #severityList>
    <mat-option *ngFor="let severity of severityOptions" [value]="severity">
      {{ severity }}
    </mat-option>
  </mat-select>
</div>
